<template>
  <div>
    <NavigationBar showBackBtn :actions="actions">
      <template v-slot:title>
        <div class="">
          <small class="mb-0 pb-0 grey--text font-weight-medium caption"
            >Sammeleingabe</small
          >
          <div class="mt-n1 pt-0 pb-2 title text-h6 font-weight-medium">
            {{ deadline.title }}
          </div>
        </div>
      </template></NavigationBar
    >
    <section>
      <template>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card-heading, table"
              ></v-skeleton-loader>
              <v-data-table
                v-else
                v-model="helpers.selectedDocuments"
                :items="documents"
                :headers="headers"
                no-data-text="Keine Einträge vorhanden"
                show-select
                :search="search"
                hide-default-footer
                item-key="user.uid"
                dense
                disable-pagination
                class="elevation-1 rounded"
              >
                <template v-slot:top>
                  <v-card flat>
                    <v-card-title class="body-2 v-card__subtitle">
                      <v-text-field
                        v-model="search"
                        label="Suchen"
                        dense
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        hide-details="auto"
                        :disabled="documents.length === 0"
                        clearable
                        class="mr-1"
                        style="max-width: 300px !important"
                      ></v-text-field>
                      <v-spacer class="hidden-sm-and-down"></v-spacer>
                      <!-- <v-btn
                        depressed
                        text
                        outlined
                        :disabled="documents.length === 0"
                        @click="validateAllDocuments()"
                        class="mr-2 my-1"
                        ><v-icon left>mdi-check-all</v-icon>Datensätze
                        validieren</v-btn
                      > -->

                      <v-btn
                        depressed
                        text
                        outlined
                        color="error"
                        class="mr-2"
                        :disabled="!helpers.selectedDocuments.length"
                        @click="deleteDocumentSelection()"
                        ><v-icon left>mdi-delete</v-icon>Auswahl löschen
                      </v-btn>

                      <v-btn
                        depressed
                        text
                        outlined
                        class="mr-2"
                        :disabled="!helpers.selectedDocuments.length"
                        @click="toggleMassEditDialog()"
                        ><v-icon left>mdi-pencil-box-multiple</v-icon>Auswahl
                        bearbeiten
                      </v-btn>
                      <new-entry-table-selector-menu
                        v-model="helpers.newEntries.personSelection"
                        :items="personsForNewEntries"
                        title="Fristeneinträge hinzufügen"
                        :additionalHeaders="
                          helpers.newEntries.additionalHeaders
                        "
                        :addBtnDisabled="addBtnDisabled"
                        @reset="resetNewEntriesForm()"
                        @submitForm="addNewEntries()"
                      >
                        <template v-slot:additionalForm>
                          <v-row dense>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="helpers.newEntries.dueDate"
                                type="date"
                                outlined
                                dense
                                hide-details="auto"
                                label="Ablaufdatum"
                                :rules="[rules.required]"
                                class="mb-2"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model.trim="helpers.newEntries.note"
                                outlined
                                dense
                                hide-details="auto"
                                clearable
                                label="Bemerkungen"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-select
                                v-model="helpers.newEntries.labels"
                                :items="deadline.availableLabels"
                                outlined
                                dense
                                multiple
                                small-chips
                                deletable-chips
                                clearable
                                hide-details="auto"
                                label="Labels"
                                class="mb-2"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </template>
                      </new-entry-table-selector-menu>
                    </v-card-title>
                    <v-divider></v-divider>
                  </v-card>
                </template>
                <template v-slot:item.deadline="{ item }">
                  <v-chip label dense>{{ item.deadline.title }}</v-chip>
                </template>
                <template v-slot:item.dueDate="{ item }">
                  <v-text-field
                    v-model="item.dueDate"
                    type="date"
                    outlined
                    :rules="[rules.required]"
                    dense
                    hide-details="auto"
                    class="my-2"
                  ></v-text-field>
                </template>
                <template v-slot:item.labels="{ item }">
                  <v-select
                    v-model="item.labels"
                    :items="deadline.availableLabels"
                    outlined
                    multiple
                    dense
                    small-chips
                    deletable-chips
                    clearable
                    hide-details="auto"
                    class="my-2"
                  ></v-select>
                </template>
                <template v-slot:item.note="{ item }">
                  <v-text-field
                    v-model="item.note"
                    outlined
                    label="Bemerkung"
                    clearable
                    dense
                    hide-details="auto"
                    class="my-2"
                  ></v-text-field>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <custom-dialog
      v-if="helpers.massEditDialog.model"
      @close="toggleMassEditDialog()"
      title="Auswahl bearbeiten"
      text="Änderungen werden auf alle ausgewählten Einträge angewendet."
      width="l"
      :btnAction="massEditAttendanceSelection"
      fullscreenOnMobile
    >
      <template v-slot:content>
        <v-form
          v-model="helpers.massEditDialog.formIsValid"
          ref="editDialogForm"
          @submit.prevent="massEditAttendanceSelection()"
        >
          <v-card outlined>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Ablaufdatum überschreiben"
                    hide-details="auto"
                    value="dueDate"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="6" sm="5" md="3">
                  <v-text-field
                    v-model="helpers.massEditDialog.newData.dueDate"
                    type="date"
                    outlined
                    dense
                    label="Ablaufdatum"
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes('dueDate')
                    "
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Labels überschreiben"
                    hide-details="auto"
                    value="labels"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                  <v-select
                    v-model="helpers.massEditDialog.newData.labels"
                    :items="deadline.availableLabels"
                    label="Labels"
                    outlined
                    dense
                    multiple
                    small-chips
                    clearable
                    deletable-chips
                    hide-details="auto"
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes('labels')
                    "
                    return-object
                    class="mt-3"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Bemerkung überschreiben"
                    hide-details="auto"
                    value="note"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                  <v-text-field
                    v-model.trim="helpers.massEditDialog.newData.note"
                    outlined
                    dense
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes('note')
                    "
                    hide-details="auto"
                    label="Bemerkung"
                    class="mt-3"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </template>
    </custom-dialog>
    <CustomDialog
      v-if="helpers.bulkImportDialog.model"
      @close="toggleBulkInputDialog()"
      title="Verarbeitungsart auswählen"
      :text="`${documents.length} ${
        documents.length === 1 ? 'Eintrag ist' : 'Einträge sind'
      } bereit für Verarbeitung`"
      :loading="helpers.bulkImportDialog.loading"
      :errorMessage="helpers.bulkImportDialog.errorMessage"
      showCloseBtn
      hideActionBtn
      width="s"
    >
      <template v-slot:content>
        <v-card outlined>
          <v-card-title class="subtitle-1 font-weight-medium pb-0"
            >Fristeneinträge direkt aktualisieren</v-card-title
          >
          <v-card-text class="pb-0">
            Die Aktualisierung der Fristeneinträge wird sofort angewendet. Es
            ist keine weitere Genehmigung erforderlich.
          </v-card-text>
          <v-card-actions class="py-3 ml-2">
            <v-btn
              depressed
              color="primary"
              :disabled="
                documents.length === 0 ||
                helpers.bulkImportDialog.suggestUpdate.loading
              "
              :loading="helpers.bulkImportDialog.directUpdate.loading"
              @click="directUpdate()"
              >Bestätigen</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card outlined class="mt-4">
          <v-card-title class="subtitle-1 font-weight-medium pb-0"
            >Aktualisierung der Fristeneinträge vorschlagen</v-card-title
          >
          <v-card-text class="pb-0">
            Die Aktualisierung der Fristeneinträge wird an den für diese Frist
            definierten Genehmigungsprozess übergeben. Die Aktualisierung wird
            erst angewendet, wenn ausstehende Genehmigungen erteilt wurden.
          </v-card-text>
          <v-card-actions class="py-3 ml-2">
            <v-btn
              depressed
              color="primary"
              :disabled="
                documents.length === 0 ||
                helpers.bulkImportDialog.directUpdate.loading
              "
              :loading="helpers.bulkImportDialog.suggestUpdate.loading"
              @click="suggestUpdate()"
              >Bestätigen</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { db, functions, Timestamp } from "@/firebase";
// import { SCHEDULING } from "@/store/modules.js";
// import { UPDATE_EVENT_TYPE } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import NewEntryTableSelectorMenu from "@/components/_systemwide/NewEntryTableSelectorMenu.vue";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { GET_PERSONNEL_RECORDS } from "@/store/action-types.js";

export default {
  name: "member-management-deadline-monitoring-deadline-bulk-input",
  components: {
    NavigationBar,
    CustomDialog,
    NewEntryTableSelectorMenu,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.toggleBulkInputDialog,
        },
      ],
      bulkActionSucceeded: false,
      dataIsLoading: true,
      search: "",
      deadline: null,
      headers: [
        {
          text: "Personalnummer",
          value: "user.personnelNumber",
          divider: true,
        },
        { text: "Vorname", value: "user.firstName" },
        { text: "Nachname", value: "user.lastName", divider: true },
        { text: "Ablaufdatum", value: "dueDate", divider: true },
        { text: "Labels", value: "labels", divider: true },
        { text: "Bemerkungen", value: "note", divider: true },
      ],
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },

      documents: [],
      deadlineEntries: [],

      helpers: {
        formIsValid: false,
        selectedDocuments: [],
        documentDeletion: {
          selection: [],
        },
        massEditDialog: {
          model: false,
          formIsValid: false,
          updateValues: [],
          newData: {
            dueDate: null,
            labels: [],
            note: "",
          },
        },
        bulkImportDialog: {
          model: false,
          loading: false,
          errorMessage: "",
          suggestUpdate: {
            loading: false,
          },
          directUpdate: {
            loading: false,
          },
        },
        newEntries: {
          personSelection: [],
          dueDate: "",
          note: "",
          labels: [],
          additionalHeaders: [
            {
              text: "Aktuelle Frist",
              value: "dueDate",
              align: "start",
              divider: true,
            },
            {
              text: "Labels",
              value: "labels",
              align: "start",
              divider: true,
            },
            {
              text: "Hinweise",
              value: "info",
              align: "start",
              divider: true,
            },
          ],
        },
      },
    };
  },
  computed: {
    personnelRecords() {
      return this.$store.state.memberManagement.personnelRecords;
    },
    personsForNewEntries() {
      return this.personnelRecords.map((record) => {
        const matchingEntry = this.deadlineEntries.find(
          (entry) => entry.user.membershipId === record.user.membershipId
        );
        if (matchingEntry) {
          return {
            ...record,
            dueDate: matchingEntry.dueDate,
            labels: matchingEntry.labels,
            note: matchingEntry.note,
            pendingUpdate: matchingEntry.pendingUpdate,
            scheduledRenewal: matchingEntry.scheduledRenewal,
          };
        }
        return {
          ...record,
          dueDate: null,
          labels: [],
          note: null,
          pendingUpdate: null,
          scheduledRenewal: null,
        };
      });
    },
    addBtnDisabled() {
      return (
        this.helpers.newEntries.personSelection.length === 0 ||
        !this.helpers.newEntries.dueDate
      );
    },
  },
  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    if (this.bulkActionSucceeded) {
      next();
      return;
    }
    const answer = window.confirm(
      "Willst Du die Seite wirklich verlassen? Nicht gespeicherte Änderungen gehen verloren."
    );
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    async initialize() {
      await this.getDeadline();
      await this.getDeadlineEntries();
      this.getPersonnelRecords();
      this.dataIsLoading = false;
    },
    async getDeadline() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("deadlines")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.deadline = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    async getDeadlineEntries() {
      try {
        const querySnapshot = await db
          .collection("organizations")
          .doc(this.$route.params.organizationId)
          .collection("deadlineEntries")
          .where("deadline.id", "==", this.$route.params.itemId)
          .get();

        if (!querySnapshot.empty) {
          const deadlineEntries = [];
          querySnapshot.forEach((doc) => {
            deadlineEntries.push({ id: doc.id, ...doc.data() });
          });
          this.deadlineEntries = deadlineEntries;
        }
      } catch (error) {
        console.error("Error querying documents:", error);
        throw error; // Re-throw the error for further handling
      }
    },
    getPersonnelRecords() {
      this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_PERSONNEL_RECORDS}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    toggleMassEditDialog() {
      this.helpers.massEditDialog.model = !this.helpers.massEditDialog.model;
    },
    massEditAttendanceSelection() {
      this.helpers.selectedDocuments.forEach((selectedItem) => {
        const deadlineEntry = this.documents.find(
          (item) => item.user.membershipId === selectedItem.user.membershipId
        );

        if (deadlineEntry) {
          if (this.helpers.massEditDialog.updateValues.includes("dueDate")) {
            deadlineEntry.dueDate = this.helpers.massEditDialog.newData.dueDate;
          }

          if (this.helpers.massEditDialog.updateValues.includes("labels")) {
            deadlineEntry.labels = this.helpers.massEditDialog.newData.labels;
          }

          if (this.helpers.massEditDialog.updateValues.includes("note")) {
            deadlineEntry.note = this.helpers.massEditDialog.newData.note;
          }
        }
      });

      // Close the dialog
      this.helpers.massEditDialog.model = false;
      this.helpers.selectedDocuments = [];
      this.helpers.massEditDialog.updateValues = [];
      this.helpers.massEditDialog.newData = {
        dueDate: null,
        labels: [],
        note: "",
      };
    },
    deleteDocumentSelection() {
      this.helpers.documentDeletion.selection = this.helpers.selectedDocuments;
      this.helpers.selectedDocuments.forEach((selectedItem) => {
        const index = this.documents.findIndex(
          (item) => item.user.membershipId === selectedItem.user.membershipId
        );
        console.log("index", index);
        console.log("selectedItem", selectedItem);
        if (index !== -1) {
          this.documents.splice(index, 1);
        }
      });
      this.helpers.selectedDocuments = [];
    },
    toggleBulkInputDialog() {
      this.helpers.bulkImportDialog.model =
        !this.helpers.bulkImportDialog.model;
    },
    resetNewEntriesForm() {
      this.helpers.newEntries.personSelection = [];
      this.helpers.newEntries.dueDate = "";
      this.helpers.newEntries.note = "";
      this.helpers.newEntries.labels = [];
    },
    addNewEntries() {
      if (this.documents.length > 100) {
        alert(
          "Es können nicht mehr als 100 Datensätze gleichzeitig hinzugefügt werden."
        );
      } else {
        this.helpers.newEntries.personSelection.forEach((person) => {
          var data = {
            user: {
              displayName: person.firstName + " " + person.lastName,
              firstName: person.firstName,
              lastName: person.lastName,
              uid: person.user.uid,
              membershipId: person.user.membershipId,
              personnelNumber: person.personnelNumber,
              division: person.division,
              status: person.status,
            },
            deadline: this.deadline,
            dueDate: this.helpers.newEntries.dueDate,
            labels: this.helpers.newEntries.labels,
            note: this.helpers.newEntries.note,
          };
          this.documents.push(data);
        });
        this.resetNewEntriesForm();
      }
    },
    removeAllDocuments() {
      var res = confirm(
        "Bist Du sicher, dass Du alle Datensätze entfernen möchtest?"
      );
      if (res == true) {
        this.documents = [];
      }
    },
    validateAllDocuments() {
      let length = this.documents.length;
      for (let i = 0; i < length; i++) {
        this.$refs.document[i].validate();
      }
    },
    sortAllDocuments() {
      this.documents = this.documents.sort(function (a, b) {
        return new Date(a.dueDate) - new Date(b.dueDate);
      });
    },
    convertToTimestamp(date, time) {
      const input = date + " " + time;
      return Timestamp.fromDate(new Date(input.replace(/-/g, "/")));
    },
    directUpdate() {
      this.helpers.bulkImportDialog.loading = true;
      this.helpers.bulkImportDialog.directUpdate.loading = true;
      this.helpers.bulkImportDialog.errorMessage = "";

      const preparedDeadlineEntries = this.documents.map((entry) => {
        if (!entry.dueDate) {
          throw new Error("A valid dueDate is required for all entries.");
        }
        const dueDate = this.convertToTimestamp(entry.dueDate, "00:00");
        return { ...entry, dueDate: dueDate };
      });

      const callFunction = functions.httpsCallable(
        "memberManagement-addDeadlineEntries"
      );
      return callFunction({
        organizationId: this.$route.params.organizationId,
        deadlineId: this.deadline.meta.id,
        deadlineEntries: preparedDeadlineEntries,
      })
        .then((result) => {
          if (result.data.success) {
            // this.showSuccess = true;
            this.bulkActionSucceeded = true;
            this.$router.push({
              name: "member-management-deadline-monitoring-deadline-details",
              params: {
                organizationId: this.$route.params.organizationId,
                itemId: this.$route.params.itemId,
              },
            });
          } else {
            this.helpers.bulkImportDialog.errorMessage =
              result.data.error.message;
            this.helpers.bulkImportDialog.loading = false;
            this.helpers.bulkImportDialog.directUpdate.loading = false;
          }
        })
        .catch((error) => {
          // handle error
          // console.error(err.errorMsg);
          console.error(error);
          // this.errorMsg = err.message;
          this.helpers.bulkImportDialog.errorMessage = error.message;
          this.helpers.bulkImportDialog.loading = false;
          this.helpers.bulkImportDialog.directUpdate.loading = false;
        });
    },
    suggestUpdate() {
      this.helpers.bulkImportDialog.loading = true;
      this.helpers.bulkImportDialog.suggestUpdate.loading = true;
      this.helpers.bulkImportDialog.errorMessage = "";

      const preparedDeadlineEntries = this.documents.map((entry) => {
        if (!entry.dueDate) {
          throw new Error("A valid dueDate is required for all entries.");
        }
        const dueDate = this.convertToTimestamp(entry.dueDate, "00:00");
        return { ...entry, dueDate: dueDate };
      });
      console.log(preparedDeadlineEntries);

      const callFunction = functions.httpsCallable(
        "memberManagement-addDeadlineEntryUpdateRequests"
      );
      return callFunction({
        organizationId: this.$route.params.organizationId,
        deadlineId: this.deadline.meta.id,
        deadlineEntries: preparedDeadlineEntries,
      })
        .then((result) => {
          if (result.data.success) {
            // this.showSuccess = true;
            this.bulkActionSucceeded = true;
            this.$router.push({
              name: "member-management-deadline-monitoring-deadline-details",
              params: {
                organizationId: this.$route.params.organizationId,
                itemId: this.$route.params.itemId,
              },
            });
          } else {
            this.helpers.bulkImportDialog = result.data.error.message;
            this.helpers.bulkImportDialog.loading = false;
            this.helpers.bulkImportDialog.suggestUpdate.loading = false;
          }
        })
        .catch((error) => {
          // handle error
          // console.error(err.errorMsg);
          console.error(error);
          // this.errorMsg = err.message;
          this.helpers.bulkImportDialog.errorMessage = error.message;
          this.helpers.bulkImportDialog.loading = false;
          this.helpers.bulkImportDialog.suggestUpdate.loading = false;
        });
    },
  },
};
</script>
